export default "__VITE_ASSET__6744f878__"